<script lang="ts" setup>
import { ref, watch } from 'vue';
import XButton from './Button.vue';
import { IcArrowLeft } from '@xpos/icons-svg';

const $emit = defineEmits(['update:modelValue', 'close']);
const $props = defineProps({
  modelValue: {
    type: Boolean,
  },
  title: {
    type: String,
  },
  titleClass: {
    type: String,
    default: '',
  },
  hiddenCloseButton: {
    type: Boolean,
    default: false,
  },
  backDisabled: {
    type: Boolean,
    default: false,
  },
  // Opt-in: when @back is bound, the header back button delegates closing to the parent
  onBack: {
    type: Function,
  },
});

const visible = ref($props.modelValue);

watch(
  () => $props.modelValue,
  (newVal) => {
    visible.value = newVal;
  },
);

const onClose = () => {
  $emit('update:modelValue', false);
  $emit('close', false);
};
</script>

<template>
  <el-dialog v-model="visible" :title="$props.title" :show-close="false" :destroy-on-close="true" @close="onClose"
    width="770px" align-center>
    <template #header>
      <div class="flex items-center">
        <div class="header-side">
          <x-button type="primary" :disabled="$props.backDisabled" @click="$props.onBack ? $props.onBack() : (visible = false)" v-if="!$props.hiddenCloseButton">
            <el-icon size="20">
              <IcArrowLeft />
            </el-icon>
          </x-button>
        </div>
        <div class="flex-1 min-w-0 overflow-hidden flex justify-center">
          <slot name="title">
            <div :class="[$props.titleClass || 'text-xl md:text-3xl', 'truncate text-center w-full']">{{ $props.title }}</div>
          </slot>
        </div>
        <div class="header-side header-right flex justify-end">
          <slot name="headerRight" />
        </div>
      </div>
    </template>
    <div class="flex justify-center h-[560px] overflow-y-auto scrollbar-hide">
      <slot />
    </div>
  </el-dialog>
</template>

<style scoped>
.scrollbar-hide::-webkit-scrollbar {
  display: none;
}
.scrollbar-hide {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.header-side {
  width: var(--el-component-size);
}
/* headerRight buttons fill the side width: x-button wrapper div and its inner el-button */
.header-right > :deep(*),
.header-right :deep(.el-button) {
  width: 100%;
}
</style>
